export default __webpack_public_path__ + "static/media/11.58ed7a2a.jpg";